import React from 'react'

import { PaginatedMenuItemsQuery } from 'src/apollo/onlineOrdering'

import { NoAvailableMenuItems } from 'public/components/default_template/no_available_menu_items/NoAvailableMenuItems'
import { useFilterCriteria } from 'public/components/default_template/filter_and_sort/FilterCriteriaContext'

import { PaginatedMenu } from './PaginatedMenu'

export type MenuContentProps = {
  loading: boolean
  usedMenuItems?:
    | NonNullable<PaginatedMenuItemsQuery['paginatedMenuItems']['items']>
    | undefined
  products?:
    | NonNullable<PaginatedMenuItemsQuery['paginatedMenuItems']['products']>
    | undefined
  channelGuid?: string
  fetchMore?: (offset: number) => void
  hasMore?: boolean
  loadingNewFilterData: boolean
  formatConfig: any
  ecommColors: any
  hideOutOfStockItems?: boolean | null
}

/** Renders the appropriate menu content based on loading state */
export const MenuContent = ({
  loading,
  usedMenuItems,
  products,
  channelGuid,
  fetchMore,
  hasMore,
  loadingNewFilterData,
  formatConfig,
  ecommColors,
  hideOutOfStockItems
}: MenuContentProps) => {
  const { filterCriteria } = useFilterCriteria()
  const hasItems = usedMenuItems?.length || products?.length

  // Show menu with items or loading skeletons
  if (hasItems || loading) {
    return (
      <PaginatedMenu
        channelGuid={channelGuid}
        menuItems={usedMenuItems ?? undefined}
        products={products ?? undefined}
        loading={loading}
        fetchMore={fetchMore ?? (() => {})}
        hasMore={hasMore}
        loadingNewFilterData={loadingNewFilterData}
        menuConfig={{
          format: formatConfig,
          colors: ecommColors
        }}
        hideOutOfStockItems={hideOutOfStockItems}
      />
    )
  }

  // Show empty state when not loading and no items, or when filters are applied that result in no items returned
  if (!loading && !hasItems) {
    // filterCriteria is always null or a non-empty object (useFilterToggle sets it to null when no filters are active)
    return <NoAvailableMenuItems isFiltered={!!filterCriteria} />
  }

  return null
}

export default MenuContent
